// TopBar.js
import React from 'react';
import {
  Box,
  Button,
  HStack,
  IconButton,
  Icon,
  Spacer,
  Tooltip,
  useBreakpointValue,
  useColorModeValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { LuMessageCircle } from 'react-icons/lu';
import { FaBars } from 'react-icons/fa';
import TopBarCompletionRing from './components/TopBarCompletionRing';

const TopBar = ({ user, onToggleSidebar }) => {
  const navigate = useNavigate();
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const pillBg = useColorModeValue('white', 'rgba(255,255,255,0.05)');
  const pillHoverBg = useColorModeValue('gray.50', 'rgba(255,255,255,0.08)');
  const pillBorder = useColorModeValue('rgba(0,0,0,0.06)', 'rgba(255,255,255,0.12)');
  const pillColor = useColorModeValue('blue.700', 'text.primary');

  const handleFeedbackClick = () => {
    navigate('/help-feedback');
  };

  return (
    <Box
      as="header"
      px={4}
      py={2}
      boxShadow="md"
      width="100%"
      maxHeight="80px"
      bg="bg.header"
      position="sticky"
      top="0"
      zIndex="1000"
    >
      <HStack justify="space-between" align="center" height="100%">
        <HStack spacing={2}>
          {user && (
              <IconButton
                aria-label="Open menu"
                icon={<Icon as={FaBars} />}
                variant="ghost"
                size="lg"
                onClick={onToggleSidebar}
                color="text.primary"
              />
          )}
        </HStack>
        <Spacer />
        {user ? (
          <HStack spacing={{ base: 1.5, sm: 3 }} flexWrap="wrap">
            <Tooltip label="Share bugs, ideas, or friction you hit" hasArrow isDisabled={isMobile}>
              <Button
                aria-label="Feedback"
                size={isMobile ? 'xs' : 'sm'}
                borderRadius="full"
                variant="outline"
                color={pillColor}
                leftIcon={<Icon as={LuMessageCircle} fontSize={isMobile ? 'md' : 'lg'} />}
                bg={pillBg}
                borderColor={pillBorder}
                boxShadow="0 1px 2px rgba(0,0,0,0.12)"
                fontWeight="semibold"
                px={isMobile ? 2 : 3.5}
                minW={isMobile ? '36px' : 'auto'}
                _hover={{
                  bg: pillHoverBg,
                  transform: 'translateY(-1px)',
                  boxShadow: '0 6px 14px rgba(0,0,0,0.18)',
                }}
                _active={{ transform: 'translateY(0)', boxShadow: '0 1px 4px rgba(0,0,0,0.2)' }}
                _focusVisible={{ boxShadow: '0 0 0 2px rgba(66,153,225,0.6)' }}
                onClick={handleFeedbackClick}
              >
                {!isMobile && 'Feedback'}
              </Button>
            </Tooltip>
            <TopBarCompletionRing condensed={isMobile} />
          </HStack>
        ) : null}
      </HStack>
    </Box>
  );
};

export default TopBar;
